import React from 'react';
import {RevenueCalendarProvider} from '../context/RevenueCalendarProvider'
import RevenueContainer from '../containers/RevenueContainer';
import UnblockCrStatus from '../../containers/UnblockCr/UnblockCrStatus';
import ElearningStatus from '../../containers/Elearning/ElearningStatus';

function Revenue(props) {
    return (
        <div className="sidebar-bottomcontent-container">
            <div className="sidebar-bottomcontent-container-row">
                {props.showUnblockModel ? <UnblockCrStatus BusinessPartnerCode={props.businessPartnerCode} setShowUnblockModel={props.setShowUnblockModel} 
                                                    showUnblockModel={props.showUnblockModel}/> : null}
                               
                {props.showElearningPopup ? <ElearningStatus BusinessPartnerCode={props.BusinessPartnerCode} setShowElearningPopup={props.setShowElearningPopup} 
                                               UserId ={props.UserId} showElearningPopup={props.showElearningPopup}/>  : null}

                <RevenueCalendarProvider onLogoutClick={props.onLogoutClick} BusinessPartnerCode={props.BusinessPartnerCode}
                    setSelectedNavItem={props.setSelectedNavItem} isLogout={props.isLogout}
                    setLogoutFalse={props.setLogoutFalse} clearSessionData={props.clearSessionData}
                    isWeekly={props.isWeekly}>
                        <RevenueContainer BusinessPartnerCode={props.BusinessPartnerCode} 
                                                    isLogout={props.isLogout}   
                                                    onLogoutClick={props.onLogoutClick}
                                                    clearSessionData={props.clearSessionData} 
                                                    UserId ={props.UserId} 
                                                    isWeekly={props.isWeekly} />
                </RevenueCalendarProvider> 
            </div>
        </div>
    );
}

export default Revenue;